import React from 'react';
import { Helmet } from 'react-helmet';

// Components
import RequireAdmin from '../../components/Admin/RequireAdmin'
import Header from '../../components/Global/Header';
import Footer from '../../components/Global/Footer';
import Profile from '../../components/Admin/Profile';

const AdminProfile = ({ appName, match, path }) => (
  <div>
    <RequireAdmin />
    <Helmet>
      <title>{appName} | Admin Profile</title>
    </Helmet>
    <Header path={ path } />
    <section className="admin">
      <div className="inner-wrap">
        <Profile profileUsername={match.params.username} />
      </div>
    </section>
    <Footer appName={ appName } />
  </div>
)

export default AdminProfile



// WEBPACK FOOTER //
// ./src/screens/Admin/AdminProfile.js